<template>
  <div :class="$style.grid_editor_container">
    <grid-input
      type="text"
      :value="value"
      text-align="end"
      :initial-select="true"
      @onInput="handleInput"
    />
  </div>
</template>

<script>
import GridInput from '../components/input.vue';

export default {
  name: 'GridDurationCellEditor',
  components: { GridInput },
  data() {
    return {
      value: '',
    };
  },
  methods: {
    handleInput(val) {
      this.value = val;
    },
  },
};
</script>

<style module src="../styles/gridEditor.less" lang="less"></style>
